// /* Maliandio V14: Collection-first related products and real collection links.
//  * Only reads products from Shopify collection products.json. No /search fallback.
//  * Does not modify StyleOMG, cart, bundle, product forms or live theme.
//  */
// (() => {
//   const FLAG = '__maliandioCollectionRelatedV14';
//   if (window[FLAG]) { window[FLAG](document); return; }

//   const shopRoot = (() => {
//     const root = window.Shopify?.routes?.root || '/';
//     return root.endsWith('/') ? root : `${root}/`;
//   })();
//   const cache = new Map();
//   const safeToken = value => /^[a-z0-9][a-z0-9-]*$/.test(String(value || '').toLowerCase()) ? String(value).toLowerCase() : '';
//   const sameName = (title, name) => String(title || '').toLowerCase().split(/[^a-z0-9]+/).includes(name);
//   const collectionUrl = handle => `${shopRoot}collections/${handle}`;
//   const productUrl = handle => `${shopRoot}products/${handle}`;

//   function collectionHandleFromUrl(value) {
//     if (!value) return '';
//     try {
//       const url = new URL(value, window.location.href);
//       if (url.origin !== window.location.origin) return '';
//       const root = `${shopRoot}collections/`;
//       if (!url.pathname.startsWith(root)) return '';
//       return safeToken(url.pathname.slice(root.length).replace(/\/$/, ''));
//     } catch (_) { return ''; }
//   }
//   function candidates(name, hintedUrl) {
//     const preferred = collectionHandleFromUrl(hintedUrl);
//     return [...new Set([preferred, `limited-${name}`, name, `name-${name}`, `custom-${name}`].filter(Boolean))];
//   }

//   async function fetchCollection(handle) {
//     const url = `${collectionUrl(handle)}/products.json?limit=50`;
//     const response = await fetch(url, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
//     if (!response.ok) return null;
//     const data = await response.json();
//     if (!data || !Array.isArray(data.products)) return null;
//     return {handle, url: collectionUrl(handle), products: data.products};
//   }

//   async function resolveCollection(name, hintedUrl) {
//     const known = candidates(name, hintedUrl);
//     const cacheKey = `${name}:${known.join(',')}`;
//     if (!cache.has(cacheKey)) {
//       cache.set(cacheKey, (async () => {
//         for (const handle of known) {
//           try {
//             const result = await fetchCollection(handle);
//             if (result) return result;
//           } catch (err) {
//             // Shopify storefront/Theme Editor can temporarily block AJAX;
//             // try the next plausible collection handle instead.
//           }
//         }
//         // Confirmed by the merchant: this is the storefront's AARON collection URL.
//         // Keep this known link usable even when Shopify blocks collection JSON.
//         if (name === 'aaron') return {handle: 'limited-aaron', url: collectionUrl('limited-aaron'), products: []};
//         return null;
//       })());
//     }
//     return cache.get(cacheKey);
//   }

//   function toCents(value) {
//     // /collections/<handle>/products.json returns decimal price strings (e.g. '31.99'),
//     // unlike /products/<handle>.js which returns integer cents.
//     if (typeof value === 'string' && value.includes('.')) return Math.round(Number(value) * 100);
//     return Math.round(Number(value) || 0);
//   }
//   function numberFormat(cents, section) {
//     const code = String(section.dataset.maliandioCurrency || window.Shopify?.currency?.active || 'USD');
//     try {
//       return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
//         style: 'currency', currency: /^[A-Z]{3}$/.test(code) ? code : 'USD'
//       }).format((Number(cents) || 0) / 100);
//     } catch (_) { return `${((Number(cents) || 0) / 100).toFixed(2)} ${code}`; }
//   }
//   function node(tag, className, label) {
//     const el = document.createElement(tag);
//     if (className) el.className = className;
//     if (label !== undefined) el.textContent = String(label);
//     return el;
//   }
//   function productImage(p) {
//     const raw = p.images?.[0]?.src || p.images?.[0] || p.featured_image?.src || p.featured_image;
//     const url = String(raw || '');
//     if (/^(https?:)?\/\//.test(url) || url.startsWith('/')) return url;
//     return '';
//   }
//   function buildCard(p, section) {
//     const handle = safeToken(p.handle);
//     if (!handle) return null;
//     const link = productUrl(handle);
//     const li = node('li', 'grid__item spc__slide');
//     const card = node('div', 'sp-card');
//     const media = node('a', 'sp-card__media');
//     media.href = link;
//     const url = productImage(p);
//     if (url) {
//       const img = node('img');
//       img.src = url;
//       img.alt = String(p.title || 'Product');
//       img.loading = 'lazy'; img.decoding = 'async';
//       media.append(img);
//     }
//     card.append(media);
//     const info = node('div', 'sp-card__info');
//     const title = node('h3', 'sp-card__title');
//     const titleLink = node('a', '', p.title || 'Product');
//     titleLink.href = link;
//     title.append(titleLink);
//     info.append(title);
//     const prices = node('div', 'sp-price');
//     const selected = p.variants?.find(v => v.available) || p.variants?.[0];
//     const price = toCents(selected?.price ?? p.price ?? 0);
//     const compare = toCents(selected?.compare_at_price ?? p.compare_at_price ?? 0);
//     prices.append(node('span', 'sp-price__sale', numberFormat(price, section)));
//     if (compare > price) prices.append(node('s', 'sp-price__compare', numberFormat(compare, section)));
//     info.append(prices);
//     card.append(info);
//     const actions = node('div', 'sp-card__actions');
//     const button = node('a', 'sp-atc', 'View product');
//     button.href = link;
//     actions.append(button);
//     card.append(actions);
//     li.append(card);
//     return li;
//   }

//   async function fillRelated(section) {
//     if (section.dataset.maliandioV14Started === 'true') return;
//     section.dataset.maliandioV14Started = 'true';
//     const name = safeToken(section.dataset.maliandioName);
//     const list = section.querySelector('[data-maliandio-result-list]');
//     if (!name || !list) return;
//     const collection = await resolveCollection(name, section.dataset.maliandioCollectionUrl);
//     if (!section.isConnected) return;
//     if (!collection) {
//       if (window.Shopify?.designMode) {
//         const status = section.querySelector('[data-maliandio-related-status]');
//         if (status) { status.textContent = `Collection for ${name.toUpperCase()} not found. Check the collection handle.`; status.hidden = false; }
//         section.hidden = false;
//       }
//       return;
//     }

//     const currentId = String(section.dataset.maliandioCurrentId || '');
//     const limit = Math.min(10, Math.max(2, parseInt(section.dataset.maliandioCount, 10) || 4));
//     const products = collection.products
//       .filter(p => String(p.id) !== currentId)
//       .filter(p => sameName(p.title, name))
//       .filter(p => section.dataset.maliandioHideSoldout !== 'true' || p.available !== false)
//       .slice(0, limit);
//     const cards = products.map(p => buildCard(p, section)).filter(Boolean);
//     const status = section.querySelector('[data-maliandio-related-status]');

//     if (cards.length) {
//       list.replaceChildren(...cards);
//       section.hidden = false;
//       if (status) status.hidden = true;
//       requestAnimationFrame(() => section.querySelector('sp-carousel')?.update?.());
//     } else if (window.Shopify?.designMode) {
//       section.hidden = false;
//       if (status) {
//         status.textContent = `Collection ${collection.handle} found, but no other matching ${name.toUpperCase()} products loaded from this collection.`;
//         status.hidden = false;
//       }
//     }
//     // View all is the actual collection URL, never a Search URL.
//     const viewAll = section.querySelector('[data-maliandio-real-collection-link]');
//     if (viewAll) {
//       viewAll.href = collection.url;
//       viewAll.hidden = false;
//       viewAll.closest('[data-maliandio-collection-slot]')?.removeAttribute('hidden');
//       section.hidden = false;
//     }
//   }

//   async function fillLink(link) {
//     if (link.dataset.maliandioV14Started === 'true') return;
//     link.dataset.maliandioV14Started = 'true';
//     const name = safeToken(link.dataset.maliandioRealCollectionLink);
//     if (!name) return;
//     const data = await resolveCollection(name, link.dataset.maliandioCollectionUrl);
//     if (!link.isConnected || !data) return;
//     link.href = data.url;
//     link.hidden = false;
//     link.closest('[data-maliandio-collection-slot]')?.removeAttribute('hidden');
//   }

//   function init(scope = document) {
//     if (scope.matches?.('[data-maliandio-related-fallback]')) fillRelated(scope);
//     scope.querySelectorAll?.('[data-maliandio-related-fallback]').forEach(fillRelated);
//     if (scope.matches?.('[data-maliandio-real-collection-link]')) fillLink(scope);
//     scope.querySelectorAll?.('[data-maliandio-real-collection-link]').forEach(fillLink);
//   }
//   window[FLAG] = init;
//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
//   else init();
//   document.addEventListener('shopify:section:load', event => init(event.target));
// })();
/* Maliandio V14: Collection-first related products and real collection links.
 * Only reads products from Shopify collection products.json. No /search fallback.
 * Does not modify StyleOMG, cart, bundle, product forms or live theme.
 */
(() => {
  const FLAG = '__maliandioCollectionRelatedV14';
  if (window[FLAG]) { window[FLAG](document); return; }

  const shopRoot = (() => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  })();
  const cache = new Map();
  const safeToken = value => /^[a-z0-9][a-z0-9-]*$/.test(String(value || '').toLowerCase()) ? String(value).toLowerCase() : '';
  const sameName = (title, name) => String(title || '').toLowerCase().split(/[^a-z0-9]+/).includes(name);
  const collectionUrl = handle => `${shopRoot}collections/${handle}`;
  const productUrl = handle => `${shopRoot}products/${handle}`;

  function collectionHandleFromUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin) return '';
      const root = `${shopRoot}collections/`;
      if (!url.pathname.startsWith(root)) return '';
      return safeToken(url.pathname.slice(root.length).replace(/\/$/, ''));
    } catch (_) { return ''; }
  }
  function candidates(name, hintedUrl) {
    const preferred = collectionHandleFromUrl(hintedUrl);
    return [...new Set([preferred, `limited-${name}`, name, `name-${name}`, `custom-${name}`].filter(Boolean))];
  }

  async function fetchCollection(handle) {
    const url = `${collectionUrl(handle)}/products.json?limit=50`;
    const response = await fetch(url, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
    if (!response.ok) return null;
    const data = await response.json();
    if (!data || !Array.isArray(data.products)) return null;
    return {handle, url: collectionUrl(handle), products: data.products};
  }

  async function resolveCollection(name, hintedUrl) {
    const known = candidates(name, hintedUrl);
    const cacheKey = `${name}:${known.join(',')}`;
    if (!cache.has(cacheKey)) {
      cache.set(cacheKey, (async () => {
        for (const handle of known) {
          try {
            const result = await fetchCollection(handle);
            if (result) return result;
          } catch (err) {
            // Shopify storefront/Theme Editor can temporarily block AJAX;
            // try the next plausible collection handle instead.
          }
        }
        // Confirmed by the merchant: this is the storefront's AARON collection URL.
        // Keep this known link usable even when Shopify blocks collection JSON.
        if (name === 'aaron') return {handle: 'limited-aaron', url: collectionUrl('limited-aaron'), products: []};
        return null;
      })());
    }
    return cache.get(cacheKey);
  }

  function toCents(value) {
    // /collections/<handle>/products.json returns decimal price strings (e.g. '31.99'),
    // unlike /products/<handle>.js which returns integer cents.
    if (typeof value === 'string' && value.includes('.')) return Math.round(Number(value) * 100);
    return Math.round(Number(value) || 0);
  }
  function numberFormat(cents, section) {
    const code = String(section.dataset.maliandioCurrency || window.Shopify?.currency?.active || 'USD');
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: /^[A-Z]{3}$/.test(code) ? code : 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch (_) { return `${((Number(cents) || 0) / 100).toFixed(2)} ${code}`; }
  }
  function node(tag, className, label) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (label !== undefined) el.textContent = String(label);
    return el;
  }
  function productImage(p) {
    const raw = p.images?.[0]?.src || p.images?.[0] || p.featured_image?.src || p.featured_image;
    const url = String(raw || '');
    if (/^(https?:)?\/\//.test(url) || url.startsWith('/')) return url;
    return '';
  }
  function buildCard(p, section) {
    const handle = safeToken(p.handle);
    if (!handle) return null;
    const link = productUrl(handle);
    const li = node('li', 'grid__item spc__slide');
    const card = node('div', 'sp-card');
    const media = node('a', 'sp-card__media');
    media.href = link;
    const url = productImage(p);
    if (url) {
      const img = node('img');
      img.src = url;
      img.alt = String(p.title || 'Product');
      img.loading = 'lazy'; img.decoding = 'async';
      media.append(img);
    }
    card.append(media);
    const info = node('div', 'sp-card__info');
    const title = node('h3', 'sp-card__title');
    const titleLink = node('a', '', p.title || 'Product');
    titleLink.href = link;
    title.append(titleLink);
    info.append(title);
    const prices = node('div', 'sp-price');
    const selected = p.variants?.find(v => v.available) || p.variants?.[0];
    const price = toCents(selected?.price ?? p.price ?? 0);
    const compare = toCents(selected?.compare_at_price ?? p.compare_at_price ?? 0);
    prices.append(node('span', 'sp-price__sale', numberFormat(price, section)));
    if (compare > price) prices.append(node('s', 'sp-price__compare', numberFormat(compare, section)));
    info.append(prices);
    card.append(info);
    const actions = node('div', 'sp-card__actions');
    const button = node('a', 'sp-atc', 'View product');
    button.href = link;
    actions.append(button);
    card.append(actions);
    li.append(card);
    return li;
  }

  async function fillRelated(section) {
    if (section.dataset.maliandioV14Started === 'true') return;
    section.dataset.maliandioV14Started = 'true';
    const name = safeToken(section.dataset.maliandioName);
    const list = section.querySelector('[data-maliandio-result-list]');
    if (!name || !list) return;
    const collection = await resolveCollection(name, section.dataset.maliandioCollectionUrl);
    if (!section.isConnected) return;
    if (!collection) {
      if (window.Shopify?.designMode) {
        const status = section.querySelector('[data-maliandio-related-status]');
        if (status) { status.textContent = `Collection for ${name.toUpperCase()} not found. Check the collection handle.`; status.hidden = false; }
        section.hidden = false;
      }
      return;
    }

    const currentId = String(section.dataset.maliandioCurrentId || '');
    const limit = Math.min(10, Math.max(2, parseInt(section.dataset.maliandioCount, 10) || 4));
    const products = collection.products
      .filter(p => String(p.id) !== currentId)
      .filter(p => sameName(p.title, name))
      .filter(p => section.dataset.maliandioHideSoldout !== 'true' || p.available !== false)
      .slice(0, limit);
    const cards = products.map(p => buildCard(p, section)).filter(Boolean);
    const status = section.querySelector('[data-maliandio-related-status]');

    if (cards.length) {
      list.replaceChildren(...cards);
      section.hidden = false;
      if (status) status.hidden = true;
      requestAnimationFrame(() => section.querySelector('sp-carousel')?.update?.());
    } else if (window.Shopify?.designMode) {
      section.hidden = false;
      if (status) {
        status.textContent = `Collection ${collection.handle} found, but no other matching ${name.toUpperCase()} products loaded from this collection.`;
        status.hidden = false;
      }
    }
    // View all is the actual collection URL, never a Search URL.
    const viewAll = section.querySelector('[data-maliandio-real-collection-link]');
    if (viewAll) {
      viewAll.href = collection.url;
      viewAll.hidden = false;
      viewAll.closest('[data-maliandio-collection-slot]')?.removeAttribute('hidden');
      section.hidden = false;
    }
  }

  function updateCollectionCount(link, data) {
    const badge = link.querySelector('[data-maliandio-collection-count]');
    if (!badge || !Array.isArray(data?.products)) return;
    const count = data.products.length;
    if (count < 1) return;
    badge.textContent = count >= 50 ? '50+ products' : `${count} ${count === 1 ? 'product' : 'products'}`;
    badge.hidden = false;
  }

  async function fillLink(link) {
    if (link.dataset.maliandioV14Started === 'true') return;
    link.dataset.maliandioV14Started = 'true';
    const name = safeToken(link.dataset.maliandioRealCollectionLink);
    if (!name) return;
    const data = await resolveCollection(name, link.dataset.maliandioCollectionUrl);
    if (!link.isConnected || !data) return;
    link.href = data.url;
    link.hidden = false;
    updateCollectionCount(link, data);
    link.closest('[data-maliandio-collection-slot]')?.removeAttribute('hidden');
    link.closest('.tst-related-collections')?.removeAttribute('hidden');
  }

  function init(scope = document) {
    if (scope.matches?.('[data-maliandio-related-fallback]')) fillRelated(scope);
    scope.querySelectorAll?.('[data-maliandio-related-fallback]').forEach(fillRelated);
    if (scope.matches?.('[data-maliandio-real-collection-link]')) fillLink(scope);
    scope.querySelectorAll?.('[data-maliandio-real-collection-link]').forEach(fillLink);
  }
  window[FLAG] = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
